import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import {Scroll} from 'vuetify/lib/directives'
import {Ripple} from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  theme: {
    light: {},
    dark: {},
  },
  directives: {
    Scroll,
    Ripple,
  },
})

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  }
})
